import { render, staticRenderFns } from "./safetyGearBuyRequest.vue?vue&type=template&id=bcdfc2da"
import script from "./safetyGearBuyRequest.vue?vue&type=script&lang=js"
export * from "./safetyGearBuyRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcdfc2da')) {
      api.createRecord('bcdfc2da', component.options)
    } else {
      api.reload('bcdfc2da', component.options)
    }
    module.hot.accept("./safetyGearBuyRequest.vue?vue&type=template&id=bcdfc2da", function () {
      api.rerender('bcdfc2da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/sas/safetyGearBuyRequest.vue"
export default component.exports